import { faker } from '@faker-js/faker'

import { TargetLanguage } from '../../contracts/service-offer'
import { AdminPricePropertyRequest } from '../../contracts/treatment/AdminPricePropertyRequest'
import { asBuilder } from '../asBuilder'

export const getAdminPricePropertyRequest = asBuilder((): AdminPricePropertyRequest => {
  const names = faker.helpers.multiple(
    () => ({
      language: faker.helpers.enumValue(TargetLanguage),
      value: faker.lorem.word(),
    }),
    { count: 3 },
  )

  return {
    names,
    values: faker.helpers.multiple(() => ({
      id: faker.string.uuid(),
      names,
    })),
  }
})
